import React from 'react';
import TrickyTowerBackground from '../../components/tower';
import PerfectTowerBackground from '../../components/perfectTower';

const TowerSlide = ({ slide, reorganize, perfect }) => {
    return (
        <div className="relative w-full h-full overflow-hidden">
            {/* Background Animation */}
            <div className="absolute inset-0 z-0">
                {perfect ? <PerfectTowerBackground /> : <TrickyTowerBackground reorganize={reorganize} />}
            </div>

            {/* Content Overlay */}
            <div className="absolute inset-0 z-10 flex flex-col p-12 pointer-events-none">
                {/* Header */}
                <div className="flex flex-col gap-2 mb-12 pointer-events-auto">
                    <div className="flex items-center gap-4">
                        <div className="h-[2px] w-12 bg-blue-400/50" />
                        <span className="text-blue-400 font-mono tracking-widest uppercase text-lg">
                            {slide.subtitle || "Concept"}
                        </span>
                        <div className="h-[2px] flex-1 bg-gradient-to-r from-blue-400/50 to-transparent" />
                    </div>
                    <h2 className="text-6xl font-bold leading-[1.4] bg-clip-text text-transparent bg-gradient-to-r from-white via-blue-100 to-blue-200">
                        {slide.title}
                    </h2>
                </div>

                {/* Content Body */}
                <div className="flex flex-1 items-center gap-12 pointer-events-auto">
                    {/* Left: Points */}
                    <div className="flex-1 flex flex-col justify-center gap-8 pl-8">
                        {slide.points && slide.points.map((point, index) => (
                            <div key={index} className="group relative pl-8 border-l-2 border-blue-500/30 hover:border-blue-500 transition-colors duration-500 bg-slate-900/60 p-4 rounded-r-lg backdrop-blur-sm">
                                <div className="absolute -left-[9px] top-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-slate-900 border-2 border-blue-500/30 group-hover:border-blue-500 transition-colors duration-500" />
                                <p className="text-2xl text-slate-200 font-light leading-relaxed">
                                    {point}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Right: Empty space to see the falling blocks */}
                    <div className="flex-1 h-full" />
                </div>
            </div>
        </div>
    );
};

export default TowerSlide;
